import React, { Component } from 'react';
import { connect } from 'react-redux'
import autoBind from 'auto-bind';
import {Translate} from "react-localize-redux";
import Select from 'react-select'

import { searchByUsersWarehouseByQuery } from '../../store/administration/WarehouseWorkersActions';


/**
 * Warehouse users  By selector container
 *
 * @class PreparedBySelector
 * @extends {Component}
 */
class WarehouseUserSelector extends Component {

    /**
     *Creates an instance of WarehouseUserSelector.
     * @param {*} props
     * @memberof WarehouseUserSelector
     */
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = {
            isLoading: true,
            usersWarehouse: [],
            warehouseUser: this.props.warehouseUser,
        }
    }

      /**
     * componentDidMount
     */
    componentDidMount() {
        if (!this.props.isLoadingUser) {
            this.props.searchByUsersWarehouse()
            .then((warehouses) => {
                let users = warehouses.map((userWarehouse) =>{
                    return {
                        value: userWarehouse.token,
                        label: userWarehouse.name
                    }
                })
                this.setState({
                    usersWarehouse:users
                })
                return warehouses.map((user) => {
                    return {
                        value: user.token,
                        label: user.name
                    }
                })
            })
        }
    }

    /**
     * On select a WarehouseUserSelector 
     *
     * @param {*} option
     * @memberof WarehouseUserSelector
     */
    onSelectedUsersWarehouseClick(option) {
        if(this.state.usersWarehouse){
            let selectedUser = this.state.usersWarehouse.find((user) => {
                return user.value === option.value
            })
            if (this.props.onUsersWarehouseSelected) {
                this.props.onUsersWarehouseSelected(selectedUser)
            }
        }
    }
  
    /**
     *  
     *
     * @returns
     * @memberof WarehouseUserSelector
     */
    render() {
        return (
            <Select 
                placeholder={<Translate id="common.searchBy" />}
                defaultValue={this.state.warehouseUser}
                options={this.state.usersWarehouse}
                onChange={this.onSelectedUsersWarehouseClick}
                isDisabled={this.props.isDisabled ? this.props.isDisabled : false}
                styles={{
                    menu: (base) => ({ ...base, zIndex: 30 })
                  }}
            />
        );
    }
}

/**
 *  Defines the properties injecteded from the store to view container
 * @param {*} state 
 */
function mapStateToProps(state){
    return {
        isLoadingUser: state.oidc.isLoadingUser,
    }
}

/**
 * Defines the actions injectes to the component 
 * @param {*} dispatch 
 */
const mapDispatchToProps = dispatch => {
    return {
        searchByUsersWarehouse:() => {
            return dispatch(searchByUsersWarehouseByQuery())
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WarehouseUserSelector);